import { render, staticRenderFns } from "./PreProjectCreatedPage.vue?vue&type=template&id=3dd05e91&"
import script from "./PreProjectCreatedPage.vue?vue&type=script&lang=js&"
export * from "./PreProjectCreatedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports